module.exports = __webpack_public_path__ + "img/m1-screenshot-04_t.18d7a001.jpg";